import { useState } from 'react';
import { View, Tooltip, TruncateText } from '@smarterservices/smarter-ui';

const RenderName = ({ firstName, lastName }) => {
    const [isTruncated, setIsTruncated] = useState(false);
    const fullName = `${firstName} ${lastName}`;

    return (
        <View as="div" maxWidth="100%">
            {isTruncated ? (
                <Tooltip
                    renderTip={fullName}
                    placement="top"
                    mountNode={() => document.body}
                >
                    <div style={{ width: '100%' }}>
                        <TruncateText onUpdate={(truncated) => setIsTruncated(truncated)}>
                            {fullName}
                        </TruncateText>
                    </div>
                </Tooltip>
            ) : (
                <TruncateText onUpdate={(truncated) => setIsTruncated(truncated)}>
                    {fullName}
                </TruncateText>
            )}
        </View>
    );
};

export default RenderName;
